import React, { useState } from 'react';
import { Button } from '../ui/button';

const CookieConsent = () => {
  // Decide visibility synchronously from localStorage on the very first
  // render (no post-mount effect/setTimeout round trip), so the banner
  // paints as early as possible instead of popping in after a delay.
  const [showBanner, setShowBanner] = useState(() => !localStorage.getItem('cookieConsent'));

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
    }
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', { 'analytics_storage': 'denied' });
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-[200] w-full max-w-2xl px-4">
      <div className="bg-stone-900 text-white rounded-xl shadow-2xl p-6">
        <h4 className="font-semibold text-lg mb-2">Notice</h4>
        <p className="text-stone-300 text-sm leading-relaxed mb-4">
          We and selected third parties use cookies or similar technologies for technical purposes and, with your consent, for other purposes as specified in the{' '}
          <a 
            href="/cookie-policy" 
            className="text-blue-400 underline hover:text-blue-300"
          >
            cookie policy
          </a>.
        </p>
        <p className="text-stone-300 text-sm leading-relaxed mb-4">
          Use the "Accept" button to consent. Use the "Reject" button to continue without accepting.
        </p>
        
        <div className="flex justify-end gap-3">
          <Button 
            onClick={handleReject}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium"
          >
            Reject
          </Button>
          <Button 
            onClick={handleAccept}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
